export enum ResultStatusCheck {
  notChecked = 'Не выбрано',
  passed = 'Пройдено',
  notPassed = 'Не пройдено',
}
